import styled from 'styled-components';
import { Stack } from '@mui/material';

export const AllLinksContainer = styled(Stack)`
  background-color: ${(props) => props.bgColor || '#FCEFD8'}; /* Default color if not provided */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 8px;
  border-radius: 4px;
  padding-top: 0;
  position: relative; 
  overflow: hidden;

  /* Apply gradient mask only when more than 3 links and not expanded */
  height: ${(props) =>
    props.isExpanded || props.linksLength <= 3
      ? 'auto'
      : 'calc(2 * 48px + 32px)'}; 
  
  mask-image: ${(props) =>
    props.isExpanded || props.linksLength <= 3
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
  -webkit-mask-image: ${(props) =>
    props.isExpanded || props.linksLength <= 3
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
`;